import React from "react";
import { Grid2 } from "@repo/ui";
import { CourseCardLoader } from "./CourseCardLoader";

const StartLearningWithSpoclearnLoader = () => {
  return (
    <Grid2 container spacing={6} role="status">
      <Grid2 size={{ sm: 1, md: 4, lg: 4 }}>
        <CourseCardLoader />
      </Grid2>
      <Grid2 size={{ sm: 1, md: 4, lg: 4 }}>
        <CourseCardLoader />
      </Grid2>
      <Grid2 size={{ sm: 1, md: 4, lg: 4 }}>
        <CourseCardLoader />
      </Grid2>
      <span className="sr-only">Loading...</span>
    </Grid2>
  );
};

export default StartLearningWithSpoclearnLoader;
